import { Support } from './models/support.model';

// interfaces
export interface ISupportPayload {
  support: Support;
}

export interface IErrorPayload {
  error: any[];
}

export enum ActionsEnum {
  FETCH_SUPPORT = 'FETCH_SUPPORT',
  FETCH_SUPPORT_SUCCESS = 'FETCH_SUPPORT_SUCCESS',
  FETCH_SUPPORT_ERROR = 'FETCH_SUPPORT_ERROR',
}

// action payload
export interface FetchSupport {
  type: ActionsEnum.FETCH_SUPPORT;
}

export interface FetchSupportSuccess {
  type: ActionsEnum.FETCH_SUPPORT_SUCCESS;
  payload: ISupportPayload;
}

export interface FetchSupportError {
  type: ActionsEnum.FETCH_SUPPORT_ERROR;
  payload: IErrorPayload;
}

// action creators
export const fetchSupport = (): FetchSupport => ({
  type: ActionsEnum.FETCH_SUPPORT,
});

export const fetchSupportSuccess = (support: Support): FetchSupportSuccess => ({
  type: ActionsEnum.FETCH_SUPPORT_SUCCESS,
  payload: {
    support,
  },
});

export const fetchSupportError = (error: any[]): FetchSupportError => ({
  type: ActionsEnum.FETCH_SUPPORT_ERROR,
  payload: {
    error,
  },
});
